(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('EditarUsuario', EditarUsuario);

    EditarUsuario.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'UsuariosService', 'GruposService', 'logger', '$location', 'UserInfoService', 'ApiBaseService'];

    function EditarUsuario($q, $scope, $animationsSrv, $routeParams, UsuariosService, GruposService, logger, $location, UserInfoService, ApiBaseService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;
        
        vm.grupos = [];
        vm.tallas = [];
        vm.estadosVacunacion = [];
        vm.categorias = [];

        vm.usuario = {
            grupoId: -1,
            tallaId: 0,
            estadoVacunacionId: 0,
            lateralidad: 0,
            sexo: 0
        };

        vm.uiData = {
            esOrganizador: UserInfoService.esOrganizador()
        };

        var promiseGrupo = getGrupos();
        var promiseTallas = getComboData(vm.tallas, 'api/Tallas', null, 'Error al cargar las tallas');
        var promiseEstadosVacunacion = getComboData(vm.estadosVacunacion, 'api/EstadosVacunacion', null, 'Error al cargar los estados de vacunacion');
        var promiseCategorias = getComboData(vm.categorias, 'api/Categorias/All', null, 'Error al cargar las Categorias');

        if(vm.usuarioId){
            getById();
        }

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getGrupos(){
            var promise = GruposService.getAll()
            .then(function(grupos){
                vm.grupos = grupos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los grupos')
            }); 
            
            return promise;
        }

        function getById(){

            $q.all([promiseGrupo, promiseTallas, promiseEstadosVacunacion, promiseCategorias])
            .then(function(){
                UsuariosService.getById(vm.usuarioId)
                .then(function(usuario){
                    usuario.fechaNacimiento = moment(usuario.fechaNacimiento).toDate();
                    usuario.categoriaId = usuario.categoriaId == null ? 0 : usuario.categoriaId;
                    vm.usuario = usuario;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del usuario')
                }); 
            });
        }

        function doFormValidations()
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'tallaId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'estadoVacunacionId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'sexo' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'lateralidad' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'usergrupo' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'categoriaId' );
        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.usuario.grupoId == -1){
                $scope.usuarioForm.usergrupo.$setValidity("different", false);
            }

            doFormValidations();

            if($scope.usuarioForm.$valid){
                if(!vm.usuario.id){
                    vm.usuario.id = 0;
                    saveUser();
                }
                else{
                    if($scope.usuarioForm.$dirty){
                        updateUser();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function saveUser() {
            var promise = UsuariosService.save(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario creado con éxito.');
                clearUserData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al crea el usuario: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un erro al crea el usuario');
                        break;
                }
            }); 
        }

        function updateUser() {
            var promise = UsuariosService.update(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario modificado con éxito.');

                if(vm.uiData.esOrganizador)
                {
                    $location.path('/usuarios');
                }
                else{
                    $location.path('/eventos');
                }
                
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

        function clearUserData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.usuario = {
                grupoId: -1,
                tipoIdentificacion: 0
            };
            // Set back to pristine.
            $scope.usuarioForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.usuarioForm.$setUntouched();
        }

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "tallaId":
                    onTallaIdChanged(property);
                    break;
                case "estadoVacunacionId":
                    onEstadoVacunacionIdChanged(property);
                    break;
                case "sexo":
                    onSexoChanged(property);
                    break;
                case "lateralidad":
                    onLateralidadChanged(property);
                    break;
                case "usergrupo":
                    onUsergrupoChanged(property);
                    break;
                case "categoriaId":
                    onCategoriaIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onTallaIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onSexoChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onEstadoVacunacionIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onLateralidadChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onUsergrupoChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onCategoriaIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

    }
})();